import React from 'react';

import moment from 'moment';

import { makeStyles } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  message: {
    backgroundColor: (theme as any).palette.secondary[50],
    padding: '8px',
    borderRadius: '15px',
    marginBottom: '8px',
    width: '100%',
  },
}));

export const PersonalizedByTeamEngineMessage = () => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.message} u-background-neutral3 u-border u-border-neutral6 u-margin-y`}
    >
      <div className="typo-subtitle u-margin-bottom">
        TeamEngine (automatically) on {moment().format('dddd, MMMM Do [at] h:mma')}{' '}
      </div>
      <div>
        <Chip
          color="primary"
          size="small"
          label="Personalized by Team Engine"
          className="u-margin-right-sm"
        />
        If there is any important information missing from an application, we&apos;ll ask the
        applicant a follow-up question to help fill the gap.
      </div>
    </div>
  );
};
